import { render, staticRenderFns } from "./knowledgePointsDialog.vue?vue&type=template&id=108f470b&scoped=true&"
import script from "./knowledgePointsDialog.vue?vue&type=script&lang=js&"
export * from "./knowledgePointsDialog.vue?vue&type=script&lang=js&"
import style0 from "./knowledgePointsDialog.vue?vue&type=style&index=0&id=108f470b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f470b",
  null
  
)

export default component.exports